import {PFModal} from '../Modal/PFModal'
import {useState} from "react";
import OrderFlag from "../Modal/OrderFlag";
import {PrinterFill, Download} from 'react-bootstrap-icons';
import axios from "axios";
import {APIBASE} from "../../config/Pfalzmarkt.config";


export default function OrderLine({orders, setShowmultiPrint, foo}) {
    const [showModal, setShowModal] = useState(false);
    const [modalOrderData, setModalOrderData] = useState([]);
    const header = "Authorization: Bearer " + localStorage.getItem("token");
    const [fileNotFound, setFileNotFound] = useState(false);

    function pfModal(order) {
        setShowModal(true);
        setModalOrderData(order);

    }

    const checkCheckboxesClicked = () => {
        const checkboxes = document.querySelectorAll('#allOrders input[type="checkbox"]');
        for (const checkbox of checkboxes) {
            if (checkbox.checked) {
                return true;
            }
        }
        return false;
    }


    async function fetchPalettenBs(documentNo, lineNo, download = false) {
        try {
            const response = await axios.get(
                APIBASE + 'api/bestellungen/palettenBs/' + documentNo + '/' + lineNo + '/' + download,
                {headers: header, responseType: 'arraybuffer'}
            );

            const data = await response.data;
            const bufferArray = new Uint8Array(data).buffer;
            const blob = new Blob([bufferArray], {
                type: "application/pdf", // Specify the MIME type of the file
            });
            const url = URL.createObjectURL(blob);
            console.log(url);
            if (download) {
                const a = document.createElement("a");
                a.href = url;
                a.download = documentNo + '_' + lineNo + ".pdf";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                console.log(url);
                URL.revokeObjectURL(url);
            } else {
                const printPdf = async (url) => {
                    const printWin = window.open(url, "_blank");
                    if (printWin) {
                        setTimeout(() => {
                            printWin.print();
                        }, 100);

                        printWin.onmouseout = function () {
                            URL.revokeObjectURL(url);
                            printWin.close();
                        }

                    }

                };

                printPdf(url);
            }

        } catch (err) {
            console.log(err.message || 'Something went wrong!');
            setFileNotFound(true);
            setTimeout(() => {
                setFileNotFound(false)
            }, 2000)
        }

    }

    return (
        <><PFModal order={modalOrderData} show={showModal} onHide={() => setShowModal(false)}
                   fetchpalettenbs={fetchPalettenBs} filenotfound={fileNotFound}/>
            <tbody id="allOrders">
            {orders && orders.map(order => (
                <tr key={order.p_id}>
                    <td>
                        {setShowmultiPrint && <><input type="checkbox" value={order.p_id} onClick={() => {
                            setShowmultiPrint(checkCheckboxesClicked())
                        }}/>&nbsp;<PrinterFill
                            title={order.d_lastPrint && "bereits gedruckt am " + order.d_lastPrint.date.slice(0, 19)}
                            style={{color: order.d_lastPrint !== null ? 'grey' : 'blue'}} onClick={() => {
                            fetchPalettenBs(order.p_documentNo, order.p_LineNo)
                        }}/>&nbsp;<Download
                            title={order.d_lastDownload && "bereits heruntergeladen am " + order.d_lastDownload.date.slice(0, 19)}
                            style={{color: order.d_lastDownload !== null ? 'grey' : 'blue'}} onClick={() => {
                            fetchPalettenBs(order.p_documentNo, order.p_LineNo, true)
                        }}/></>}&nbsp;
                        <span onClick={() => pfModal(order)}>{order.f_color &&
                            <OrderFlag color={order.f_color}/>}
                            {order.p_description} {order.p_grade} {order.p_Caliber}</span>
                    </td>
                    <td>{order.p_directSaleCustomerName}</td>
                    <td>{order.p_outstandingQty} von {order.p_quantityBase}</td>
                    <td>{order.p_palletQuantity} x {order.p_ItemDescription} / {order.p_PalletDescription}
                        <h6>Stellhöhe: {order.p_colliPerPallet} {order.p_unitOfMeasureCode}</h6>
                    </td>
                    <td>{order.p_SealofQuality}</td>
                    <td>{order.p_Lieferzeit !== '00:00' && <>bis: {order.p_Lieferzeit}</>}
                        {order.p_Notice && <>{order.p_Notice}<br/></>}{order.p_servedByIcRemark}</td>
                    <td>{order.p_expectedReceiptDate}</td>
                </tr>
            ))}
            </tbody>
        </>
    );
}